import React, { useState, useMemo } from "react";
import { Typography, FormHelperText } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

const CustomTimePicker = ({
  label,
  id,
  value,
  onTimeChange,
  isMandatoryField = false,
  disabled,
  error,
  helperText,
  autoFocus = false,
  errorMessage,
  name,
  modal,
}) => {
  const [selectValue, setSelectValue] = useState(null);
  const [open, setOpen] = useState(false);

  const mandatoryRequiredButton = useSelector(
    (state) => state.mandatoryFields.isMandatoryRequiredEnabled
  );
  const viewEnabled = useSelector(
    (state) => state.mandatoryFields.isViewEnabled
  );

  useMemo(() => {
    if (value) {
      const parsedTime = dayjs(value, "HH:mm");
      setSelectValue(parsedTime.isValid() ? parsedTime : null);
    } else {
      setSelectValue(null);
    }
  }, [value]);

  const handleTimeChange = (time) => {
    setSelectValue(time);
    const formattedTime = time.format("HH:mm");
    onTimeChange(formattedTime, name, isMandatoryField);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Typography variant="labelSm" color={"text.primary"} component={"label"}>
        {label}
        {isMandatoryField && (
          <Typography component={"span"} color={"error"}>
            *
          </Typography>
        )}
      </Typography>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          ampm={false}
          autoFocus={autoFocus}
          onOpen={() => setOpen(true)}
          id={id}
          value={selectValue}
          open={open}
          onClose={handleClose}
          onChange={handleTimeChange}
          type="time"
          sx={{ width: "100%" }}
          name={name}
          disabled={
            viewEnabled ||
            (mandatoryRequiredButton && !isMandatoryField) ||
            disabled
          }
          slotProps={{
            textField: {
              helperText: helperText,
              error: error,
              readOnly: true,
              InputProps: {
                placeholder: disabled ? "" : "HH:MM",
              },
              onClick: () => setOpen(true),
            },
            popper: {
              className: modal && "zIndex-1400",
            },
          }}
        />
      </LocalizationProvider>
      {error && (
        <FormHelperText sx={{ color: "red", borderColor: "red" }}>
          {errorMessage}
        </FormHelperText>
      )}
    </>
  );
};

export default CustomTimePicker;
